/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import apiClient from '../api/client';

export const serviceRequestService = {
  // GET /api/service-requests
  getServiceRequests: (params = {}) => apiClient.get('/service-requests', { params }),

  // GET /api/service-requests/status-counts
  getStatusCounts: () => apiClient.get('/service-requests/status-counts'),

  // GET /api/service-requests/:uid
  getServiceRequestById: (uid) => apiClient.get(`/service-requests/${uid}`),

  // POST /api/service-requests
  createServiceRequest: (payload) => apiClient.post('/service-requests', payload),

  // PATCH /api/service-requests/:uid
  updateServiceRequest: (uid, payload) => apiClient.patch(`/service-requests/${uid}`, payload),

  // DELETE /api/service-requests/:uid
  deleteServiceRequest: (uid) => apiClient.delete(`/service-requests/${uid}`),

  // GET /api/service-requests/:uid/events
  getEvents: (uid) => apiClient.get(`/service-requests/${uid}/events`),

  // POST /api/service-requests/:uid/live-session-joined
  logLiveSessionJoined: (uid, payload) => apiClient.post(`/service-requests/${uid}/live-session-joined`, payload),

  // GET /api/service-requests/:uid/notes
  getNotes: (uid) => apiClient.get(`/service-requests/${uid}/notes`),

  // POST /api/service-requests/:uid/notes
  addNote: (uid, note) => apiClient.post(`/service-requests/${uid}/notes`, { note }),

  // GET /api/service-requests/:uid/media-items
  getMediaItems: (uid) => apiClient.get(`/service-requests/${uid}/media-items`),

  // DELETE /api/service-requests/:uid/media-items/:mediaUid
  removeMediaItem: (uid, mediaUid) => apiClient.delete(`/service-requests/${uid}/media-items/${mediaUid}`),

  // GET /api/service-requests/:uid/public-link
  getPublicLink: (uid) => apiClient.get(`/service-requests/${uid}/public-link`),

  // POST /api/service-requests/:uid/public-link
  createPublicLink: (uid, payload) => apiClient.post(`/service-requests/${uid}/public-link`, payload),

  // POST /api/service-requests/:uid/public-link/regenerate
  regeneratePublicLink: (uid, payload) => apiClient.post(`/service-requests/${uid}/public-link/regenerate`, payload),

  // PATCH /api/service-requests/:uid/public-link
  updatePublicLinkExpiry: (uid, payload) => apiClient.patch(`/service-requests/${uid}/public-link`, payload),

  // DELETE /api/service-requests/:uid/public-link
  revokePublicLink: (uid) => apiClient.delete(`/service-requests/${uid}/public-link`),
};
